export default {"src":"/login-app/[GIT_HASH]/_next/static/media/support.8c3c0f81.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};